import React from "react";
import { CircleAlert, Hourglass } from "lucide-react";

interface StatusAction {
  label: string;
  onClick: () => void;
}

interface StatusMessageProps {
  tone: "pending" | "error";
  title: string;
  message: string;
  action?: StatusAction;
}

/** A centred notice for list and report states: still running, failed, not found. */
const StatusMessage: React.FC<StatusMessageProps> = ({ tone, title, message, action }) => {
  const Icon = tone === "pending" ? Hourglass : CircleAlert;
  return (
    <div className={`sla-status sla-status--${tone}`} role={tone === "error" ? "alert" : "status"}>
      <Icon className="sla-status__icon" size={28} aria-hidden />
      <h2 className="sla-status__title">{title}</h2>
      <p className="sla-status__message">{message}</p>
      {action && (
        <button type="button" className="button button--outline" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
};

export default StatusMessage;
